import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Alert,
} from "@mui/material";
import Header from "../components/UserNavebar";
import Footer from "../components/Footer";
import World from "../assets/Images/world-map.png";
import { postData } from "../services/Request";
import { toast } from 'react-toastify';

const AdvanceSearchForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    gender: "",
    postalCode: "",
    address: "",
  });

  const handleChange = (field) => (event) => {
    setFormData({ ...formData, [field]: event.target.value });
  };

  const handleAdvanceSearch = async () => {
    setError("");
    setLoading(true)
    localStorage.setItem('search','advance')
    // Count filled fields from name, dob, gender
    let filledCount = 0;
    if (formData.name.trim()) filledCount++;
    if (formData.dob.trim()) filledCount++;
    if (formData.gender.trim()) filledCount++;
  
    if (filledCount < 2) {
      setError("Please fill in at least two fields (name, date of birth, gender)");
      return;
    }
  
    // Filter out empty fields
    const payload = Object.fromEntries(
      Object.entries(formData).filter(([_, value]) => value.trim() !== "")
    );
  
    // Agar sirf DOB ka year bhejna hai
    if (payload.dob) {
      payload.dob = new Date(payload.dob).getFullYear().toString();
    }
  
    try {
      const response = await postData("api/profile/search/advanced", payload);
  
      if (response.status === true) {
        navigate("/Matches", { state: { results: response.profiles } });
        setLoading(false)
      } else {
        toast.error("No matches found.");
        setLoading(false)
      }
    } catch (err) {
      toast.error("An error occurred while searching. Please try again.");
      console.error(err);
      setLoading(false)
    }
  };
  
  return (
    <>
      <Header />
      <Box
        sx={{
          backgroundImage: `url(${World})`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          bgcolor: "#f4f6f8",
          minHeight: "80vh", // تھوڑا vertical space
        }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 900,
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: "bold",
                textAlign: "center",
                color: "#333",
              }}
            >
              Advanced Search
            </Typography>
            <Typography
              sx={{
                mb: 4,
                fontWeight: "bold",
                textAlign: "center",
                color: "#5c5050",
              }}
            >
              Fill the following fields to search for the details of a user. At
              least two fields are needed for the search.
            </Typography>
            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}
            {/* Row with 4 fields */}
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Full Name"
                  value={formData.name}
                  onChange={handleChange("name")}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Date of Birth"
                  InputLabelProps={{ shrink: true }}
                  value={formData.dob}
                  onChange={handleChange("dob")}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  select
                  label="Gender"
                  value={formData.gender}
                  onChange={handleChange("gender")}
                >
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Postal Code"
                  value={formData.postalCode}
                  onChange={handleChange("postalCode")}
                />
              </Grid>
            </Grid>

            {/* Residential Address */}
            <Box sx={{ mt: 3 }}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                label="Residential Address"
                value={formData.address}
                onChange={handleChange("address")}
              />
            </Box>

            {/* Buttons */}
            <Box
              sx={{
                mt: 4,
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                justifyContent: "center",
              }}
            >
              <Button
                variant="contained"
                onClick={handleAdvanceSearch}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  px: 3,
                  py: 1.2,
                  background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                  },
                }}
              >
                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Advanced Search"}
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate("/BasicSearch")}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  borderColor: "black",
                  color: "black",
                  px: 3,
                  py: 1.2,
                  "&:hover": {
                    background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                    color: "white",
                  },
                }}
              >
                Switch to Basic Search
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate("/ComprehensiveSearch")}
                sx={{
                  textTransform: "none",
                  fontWeight: "bold",
                  borderColor: "black",
                  color: "black",
                  px: 3,
                  py: 1.2,
                  "&:hover": {
                    background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                    color: "white",
                  },
                }}
              >
                Switch to Comprehensive Search
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Footer />
    </>
  );
};

export default AdvanceSearchForm;
